/* eslint-disable */
/* tslint:disable */

import {
	EmployeeResponse,
	OrganizationParams,
	OrganizationResponse,
	OrganizationSimpleResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Organizations<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Получить список сотрудников по организации
	 * @request GET:/organizations/{id}/employees
	 * @secure
	 */
	employeesDetail = (
		id: number,
		query: {
			/**
			 * part
			 * @format int32
			 */
			part: number;
			/**
			 * count
			 * @format int32
			 */
			count: number;
		},
		params: RequestParams = {},
	) =>
		this.request<EmployeeResponse[], void>({
			path: `/organizations/${id}/employees`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Список головных организаций
	 * @request GET:/organizations
	 * @secure
	 */
	organizationsList = (params: RequestParams = {}) =>
		this.request<OrganizationResponse[], void>({
			path: `/organizations`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Добавление организации
	 * @request POST:/organizations
	 * @secure
	 */
	organizationsCreate = (data: OrganizationParams, params: RequestParams = {}) =>
		this.request<OrganizationResponse, void>({
			path: `/organizations`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Список доступных организаций (категорирование)
	 * @request GET:/organizations/categorization
	 * @secure
	 */
	categorizationList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationResponse[], void>({
			path: `/organizations/categorization`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Список головных организаций (категорирование)
	 * @request GET:/organizations/categorization/parent
	 * @secure
	 */
	categorizationParentList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationResponse[], void>({
			path: `/organizations/categorization/parent`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Список дочерних организаций (категорирование)
	 * @request GET:/organizations/categorization/children
	 * @secure
	 */
	categorizationChildrenList = (
		query: {
			/**
			 * id родительской организации
			 * @format int32
			 */
			id: number;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationResponse[], void>({
			path: `/organizations/categorization/children`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @name DocumentsList
	 * @summary Список организаций (просмотр документов)
	 * @request GET:/organizations/documents
	 * @secure
	 */
	documentsList = (params: RequestParams = {}) =>
		this.request<OrganizationSimpleResponse[], void>({
			path: `/organizations/documents`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Список организаций (просмотр шаблонов документов)
	 * @request GET:/organizations/document-patterns
	 * @secure
	 */
	documentPatternsList = (
		query: {
			/**
			 * page
			 * @format int32
			 */
			page: number;
			/**
			 * num
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationSimpleResponse[], void>({
			path: `/organizations/document-patterns`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description Поиск осуществляется по полям краткого и полного наименования организации
	 *
	 * @tags Организации
	 * @summary Список всех организаций
	 * @request GET:/organizations/all
	 * @secure
	 */
	getOrganizations = (
		query?: {
			/** поисковый запрос */
			query?: string;
			/** true - архивные, false - не архивные */
			archived?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationResponse[], void>({
			path: `/organizations/all`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Список всех организаций (только наименования)
	 * @request GET:/organizations/all/simple
	 * @secure
	 */
	allSimpleList = (
		query: {
			/**
			 * page
			 * @format int32
			 */
			page: number;
			/**
			 * num
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationSimpleResponse[], void>({
			path: `/organizations/all/simple`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Организации
	 * @summary Список дочерних организаций
	 * @request GET:/organizations/children
	 * @secure
	 */
	childrenList = (
		query: {
			/**
			 * id родительской организации
			 * @format int32
			 */
			id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationResponse[], void>({
			path: `/organizations/children`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
}
export const organizationsAPI = new Organizations();
